module.exports = __webpack_public_path__ + "img/ic_mpe_chair_sm2_normal.be71e949.png";